import React, { createContext, memo, useCallback } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Spinner,
  Button,
} from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import { Link, useRouteMatch } from 'react-router-dom';
import ReportRequestService from 'services/report-request';
// import Unauthorized from 'components/Unauthorized';
// import Loading from 'components/Loading';
import NewTable from 'components/NewTable';
import "./style.scss";
import Axios from 'axios';
import PageNotFound from 'components/Error/PageNotFound';
import UnauthorizedAccess from 'components/Error/UnauthorizedAccess';

function Tabs({list, onChange}){
  const [l] = useState(list ?? [])
  const [current_index, set_current_index] = useState(0);
  return (
    <Col xs="12">
      <Row className='report-tabs'>
        {l.map((item, index)=>{
          return (
            <Col xs="auto" className={'report-tab'+(index==current_index?" report-tab-selected":"")} onClick={()=>{
              set_current_index(index);
              if(onChange)onChange(index);
            }}>
              <label>{item.name}</label>
            </Col>
          );
        })}
      </Row>
    </Col>
  );
}

const Filters = memo(({filterList, filterOptions, handleFilterChange, tabIndex})=>{
  return (
    <Row>
      {filterList.map((f, k) => {
        if(f.type === "text"){
          return (
            <Col xs="auto" key={`${k}_${tabIndex}`}>
              <Form.Group>
                <Form.Label>{f.title}:</Form.Label>
                <Form.Control
                  size="sm"
                  // defaultValue={filters[f.param_id]}
                  onChange={(e) => {
                    let value = { page: 1 };
                    value[f.param_id] = e.target.value;
                    handleFilterChange(value);
                  }}
                >
                </Form.Control>
              </Form.Group>
            </Col>
          );
        }
        return (
          <Col xs="auto" key={`${k}_${tabIndex}`}>
            <Form.Group>
              <Form.Label>{f.title}:</Form.Label>
              <Form.Control
                as="select"
                size="sm"
                // defaultValue={filters[f.param_id]}
                onChange={(e) => {
                  let value = { page: 1 };
                  value[f.param_id] = e.target.value;
                  handleFilterChange(value);
                }}
              >
                {filterOptions[f.filter_key].map((item, k_item)=>{
                  return (
                    <option value={item.value} key={k_item}>{item.label}</option>
                  );
                })}
              </Form.Control>
            </Form.Group>
          </Col>
        );
      })}
    </Row>
  )
})

function RenderPage({report, tabIndex}){
  const defaultFilters = {search: '', per_page: 10, page: 1};
  const [filters, setFilters] = useState(defaultFilters);

  const defaultResponseData = {
    data:[],
    pagination:{
      current_page: 0,
      from: 0,
      last_page: 0,
      next_page: 0,
      per_page: 0,
      to: 0,
      total: 0
    },
    load:true
  };
  
  const [responseData, setResponseData] = useState(defaultResponseData);

  const handleFilterChange = useCallback((new_filters, reset = false) => {
    setFilters((old)=>{
      let f = { ...old, ...new_filters };
      if (reset) f = { ...defaultFilters, ...new_filters };
      return f;
    });
  },[]);

  useEffect(()=>{
    if(report){
      let data = report.tabs[tabIndex];
      if(data.required_params){
        let aux_filter = {};
        for (let i = 0; i < data.required_params.length; i++) {
          const __required = data.required_params[i];
          let aux = data.filters.filter(_f=>_f.param_id == __required);
          if(aux){
            aux_filter[__required] = report.filters[aux[0].filter_key][0].value;
          }
        }
        handleFilterChange(aux_filter, true)
      }
    }
  }, [report, tabIndex]);

  useEffect(()=>{
    setResponseData(defaultResponseData);
    let token_cancel_request = Axios.CancelToken.source();

    function conn(filters){
      let filter_clear = {};
      Object.keys(filters).forEach((f)=>{
        if(`${filters[f]}`.length > 0){
          filter_clear[f] = filters[f];
        }
      })
      ReportRequestService.getReportData(report.slug, {...filter_clear, __tab_index: tabIndex}, token_cancel_request.token).then(({data})=>{
        setResponseData(data)
      })
    }
    let to = null;
    if(report != null){
      to = setTimeout(() => {
        conn({...filters});
      }, 100);
    }
    return () => {
      token_cancel_request.cancel('Apenas cancelada');
      clearTimeout(to);
    }
  },[report, filters, tabIndex])

  return (
    <Card.Body className="card-dashboard bg-white rounded p-3 col-12">
      <Row className="align-items-center justify-content-between">
        <Col>
          <Filters 
            filterList={report.tabs[tabIndex].filters} 
            tabIndex={tabIndex} 
            filterOptions={report.filters} 
            handleFilterChange={handleFilterChange}
          />
        </Col>
        <Col xs="auto" className="align-items-end">
          <Button
            size="sm"
            onClick={async(e) => {
              const element = e.target;
              element.disabled = true;
              element.style.width = `${parseFloat(e.target.getBoundingClientRect().width).toFixed(1)}px`;
              let load = `<div role="status" class="spinner-border spinner-border-sm"></div>`
              let backup_text = element.innerHTML;
              element.innerHTML = load;
              ReportRequestService.getToken(report.slug, filters).then(({data})=>{
                element.innerHTML = backup_text;
                element.disabled = false;
                window.open(ReportRequestService.getUrlDownload(data), '_blank')
              })
            }}
          >
            Exportar
          </Button>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <NewTable
            data={responseData.data}
            columns={report.tabs[tabIndex].columns}
            pagination={responseData.pagination}
            isLoading={responseData.load}
            handlePageChange={page => handleFilterChange({ page })}
            handlePerPageChange={per_page=>handleFilterChange({ per_page, page: 1 })}
            handleSearchChange={search=>handleFilterChange({ search, page: 1 })}
            expandRow={report.tabs[tabIndex].expand_row}
            expandRowColumns={report.tabs[tabIndex].expand_row_columns}
          />
        </Col>
      </Row>
    </Card.Body>
  );
}

export default function DynamicReports(){
  const {params} = useRouteMatch();
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [report, setReport] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [pageError, setPageError] = useState(0);
  
  useEffect(()=>{
    ReportRequestService.getReport(params.report).then(async({data})=>{
      async function getFilterData(filters){
        let filters_area = {};
        for (let i = 0; i < filters.length; i++) {
          const filter = filters[i];
          let {data:list} = await ReportRequestService.getFilterData(filter);
          filters_area[filter] = list
        }
        return filters_area;
      }

      let f = await getFilterData(data.filters);
      setReport({
        ...data,
        filters: f
      });
      setIsLoadingPage(false);
    }).catch(d=>{
      setPageError(d.response.status);
    })
  },[params])

  function show_error(error){
    switch (error) {
      case 403:
        return <UnauthorizedAccess/>;
      case 404:
        return <PageNotFound/>;
      default:
        return <></>;
    }
  }

  if(pageError !== 0){
    return show_error(pageError);
  }

  if(isLoadingPage){
    return (
      <Container fluid>
        <Row className='justify-content-center'>
          <Col xs="auto">
            <Spinner animation="border" variant="primary" />
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <>
      <Container fluid>
        <Row className="mt-4">
          <Link to="/elite/reports" className="link-back">
            <ArrowBackIos className="icon-title icon-back" />
            <h6 className="font-13 mt-3">Voltar</h6>
          </Link>
        </Row>
        <Row className="mt-2">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Relatório - {report.name}</h5>
        </Row>
        <Row className="report-wrapper" style={{borderRadius: "10px"}}>
          {report.tabs.length > 1?(
            <Tabs list={report.tabs.map(tab=>({name:tab.tab_name}))} onChange={(i)=>{
              setTabIndex(i)
            }}/>
          ):<></>}
          <RenderPage report={report} tabIndex={tabIndex}/>
        </Row>
      </Container>
    </>
  );
}